import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { useCRM } from '../../context/CRMContext';
import BaseModal from './BaseModal';

const CreateDocumentModal = ({ isOpen, onClose, company, dealId }) => {
  const { contractTemplates, addActivity } = useCRM();
  const [templateId, setTemplateId] = useState('');
  const [docName, setDocName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const tmpl = contractTemplates.find(t => t.id === templateId);
    const documentName = docName || tmpl?.name || 'Nytt dokument';

    try {
      setError('');
      await Promise.resolve(addActivity({
        title: documentName,
        type: 'Dokument',
        status: 'Gjennomført',
        date: new Date().toISOString(),
        company_id: company.company_id,
        deal_id: dealId || null,
        description: tmpl?.name || tmpl?.type || 'Dokument opprettet uten mal'
      }));

      onClose();
      setTemplateId('');
      setDocName('');
    } catch (submitError) {
      setError('Kunne ikke opprette dokumentet. Prøv igjen.');
    }
  };

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title={`Opprett dokument for ${company?.name}`}>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Velg Mal</label>
          {contractTemplates.length > 0 ? (
            <select value={templateId} onChange={(e) => {
              setTemplateId(e.target.value);
              if(!docName) {
                 const t = contractTemplates.find(x => x.id === e.target.value);
                 if(t) setDocName(`${t.name} - ${company?.name}`);
              }
            }} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:border-blue-500 font-medium text-sm">
              <option value="">-- Velg mal --</option>
              {contractTemplates.map(t => <option key={t.id} value={t.id}>{t.name} ({t.type})</option>)}
            </select>
          ) : (
            <div className="p-3 bg-amber-50 text-amber-800 rounded-xl text-sm font-medium border border-amber-200">
              Du har ingen dokumentmaler enda. Opprett en under "Dokumentmaler" i hovedmenyen.
            </div>
          )}
        </div>
        
        <div className="animate-in fade-in slide-in-from-top-2">
          <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Dokumentnavn</label>
          <input 
            value={docName} 
            onChange={e => setDocName(e.target.value)} 
            className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:border-blue-500 font-medium text-sm" 
          />
        </div>

        {error && (
          <p className="text-sm font-medium text-red-600" role="alert">
            {error}
          </p>
        )}
        
        <div className="flex justify-end gap-3 pt-4 border-t border-slate-100">
          <button type="button" onClick={onClose} className="px-6 py-3 text-slate-500 font-bold hover:bg-slate-50 rounded-xl transition-colors text-sm">
            Avbryt
          </button>
          <button type="submit" className="px-6 py-3 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-colors disabled:opacity-50 shadow-lg text-sm flex items-center gap-2">
            <SafeIcon icon="📄" /> Opprett dokument
          </button>
        </div>
      </form>
    </BaseModal>
  );
};

export default CreateDocumentModal;